import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2';
import vuetify from './plugins/vuetify'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

Vue.use(VueClipboard);

Vue.use(VuePlyr, {
  plyr: {}
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  // created() {
  //   this.$store.dispatch('user/checkAuth');
  // },
  render: h => h(App),
}).$mount('#app')


